export type PivotGroup = {
  key: string;
  label: string;
  level: number;
  count: number;
  collapsed: boolean;
};

export type PivotRow<T> =
  | { kind: "group"; group: PivotGroup }
  | { kind: "row"; row: T };

export type PivotConfig<T> = {
  groupBy: (row: T) => string;
  label: (key: string) => string;
};

export const buildPivotRows = <T>(
  data: T[],
  config: PivotConfig<T>,
  collapsed: Record<string, boolean>
): PivotRow<T>[] => {
  const groups = new Map<string, T[]>();

  data.forEach((r) => {
    const k = config.groupBy(r);
    if (!groups.has(k)) groups.set(k, []);
    groups.get(k)!.push(r);
  });

  const out: PivotRow<T>[] = [];

  for (const [key, items] of groups.entries()) {
    const isCollapsed = collapsed[key] ?? false;

    out.push({
      kind: "group",
      group: {
        key,
        label: config.label(key),
        level: 0,
        count: items.length,
        collapsed: isCollapsed,
      },
    });

    if (!isCollapsed) {
      for (const r of items) {
        out.push({ kind: "row", row: r });
      }
    }
  }

  return out;
};
